// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-padding {
  padding: 12px;
}

.ion-margin {
  margin: 12px;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: #fff;
}

swiper-slide {
  width: 100% !important;
}

.image-wrapper {
  width: 100%;
  position: relative;
  aspect-ratio: 512/316;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-wrapper ion-img {
  height: 100%;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
  object-fit: contain;
}
.image-wrapper .default-img {
  background-color: #fff;
  height: 100%;
  width: 78%;
  --logo-color: var(--ion-color-primary);
}
.image-wrapper .info-product-icon {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
}
.image-wrapper .img-info {
  position: absolute;
  bottom: -16px;
  right: 3%;
  font-family: AppFont;
  font-size: 11px;
  color: var(--ion-color-danger);
}
@media (max-width: 992px) {
  .image-wrapper .img-info {
    font-size: 9px;
  }
}

.slide-col {
  top: 0;
  bottom: 80px;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  padding-bottom: 120px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.option-group-col {
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
  padding: 0 11px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-btn {
  cursor: pointer;
  position: absolute;
  margin: 0;
  font-size: 40px;
  top: 10px;
  left: 10px;
  z-index: 1;
}

ion-toolbar {
  --ion-toolbar-color: white;
  --ion-toolbar-background: var(--ion-color-primary);
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  height: 36px;
  width: 36px;
  padding: 8px;
}

.menge {
  margin-inline: 16px;
  padding: 16px 0 !important;
  border-top: var(--outline-default);
  border-bottom: var(--outline-default);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge .quantity {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 21.8px;
  text-align: left;
  color: var(--color-black);
}
.select-size {
  text-align: left;
  padding: 10px 25px !important;
  display: flex;
  flex-direction: column;
}
.select-size ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.info {
  text-align: left;
  padding: 24px 16px !important;
}
.info .title {
  font-family: AppFontMedium;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
  margin: 0px 0px 16px;
  width: 100%;
  padding-bottom: 3px;
}
.info .desc {
  font-family: AppFont;
  font-size: 14px;
  line-height: 150%;
  vertical-align: middle;
  color: var(--color-grey);
}
.info .measurement {
  font-size: 12px;
  line-height: 110%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title > span {
  display: inline-flex;
  align-items: center;
}

.info-icon {
  margin-left: 5px;
  position: relative;
  left: unset;
  right: unset;
  bottom: unset;
  top: unset;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.qty-row {
  margin: 10px 0;
}
.qty-row h2 {
  font-size: 18px;
}

.size-picker {
  margin-top: 20px;
}
.size-picker .chip {
  background: #f5f5f5;
  color: #000;
}
.size-picker .chip.selected {
  background: #000;
  color: #fff;
  font-weight: 500;
}

.step-counter {
  color: var(--ion-color-primary);
}

.first-toolbar {
  padding: 12px;
  backdrop-filter: blur(3px);
  color: black;
}

.option-group-description {
  margin: 20px 16px 0;
  color: var(--color-black);
  font-family: AppFontMedium;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  text-align: left;
}

.first-page-header {
  background: red;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
.first-page-header ion-icon {
  zoom: 1.7;
  margin: 0px 5px;
  width: 8%;
}
.first-page-header ion-title {
  text-align: left;
}

.button-price {
  margin-left: 10px;
}

.header-block {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.header-block ion-icon {
  zoom: 0.6;
}

app-tag:has(ion-icon) {
  margin-top: 7px;
  margin-bottom: 16px;
}

ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.footer-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 80px;
  width: 100%;
  z-index: 999;
  background: white;
  padding: 16px;
}

.footer-button {
  width: 100%;
  height: 54px;
  margin: 0;
}
.footer-button span {
  font-family: AppFontMedium;
  color: var(--color-white);
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

app-universal-page-toolbar {
  --title-width: 192px;
}

.error-message {
  font-size: 12px;
  margin: 0;
  margin-left: 16px;
  margin-top: 6px;
  text-align: start;
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,aAAA;AAJD;;AAOA;EACC,YAAA;AAJD;;AAOA;EACC,aAAA;EACA,kBAAA;AAJD;;AAOA;EACC,sBAAA;EACA,uBAAA;EACA,sBAAA;AAJD;;AAOA;EACC,sBAAA;AAJD;;AAOA;EACC,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJD;AAMC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJF;AAWC;EACC,sBAAA;EACA,YAAA;EACA,UAAA;EACA,sCAAA;AATF;AAYC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAVF;AAaC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EAEA,oBAAA;EACA,eAAA;EACA,8BAAA;AAZF;AClDE;EDuDD;IAUE,cAAA;EAXD;AACF;;AAeA;EACC,MAAA;EACA,YA5Ee;EA6Ef,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;EACA,iCAAA;AAZD;;AAeA;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAZD;;AAeA;EACC,YAAA;EACA,cAAA;AAZD;;AAeA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAZD;;AAeA;EACC,0BAAA;EACA,kDAAA;AAZD;AAcC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAZF;AAeC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AAbF;;AAgBA;EACC,mBA/HgB;EAgIhB,0BAAA;EACA,kCAAA;EACA,qCAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAdD;AAgBC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAdF;AAsBA;EACC,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;AApBD;AAqBC;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAnBF;;AAsBA;EACC,gBAAA;EACA,6BAAA;AAnBD;AAqBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;EACA,oBAAA;EAGA,WAAA;EACA,mBAAA;AAtBF;AAyBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,wBAAA;AAxBF;AA2BC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAzBF;;AA6BA;EACC,oBAAA;EACA,mBAAA;AA1BD;;AA6BA;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA1BD;;AA6BA;EACC,cAAA;AA1BD;AA4BC;EACC,eAAA;AA1BF;;AA8BA;EACC,gBAAA;AA3BD;AA6BC;EACC,mBAAA;EACA,WAAA;AA3BF;AA6BE;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;AA3BH;;AAgCA;EACC,+BAAA;AA7BD;;AAgCA;EACC,aAAA;EACA,0BAAA;EACA,YAAA;AA7BD;;AAgCA;EACC,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;AA7BD;;AAgCA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AA7BD;AA8BC;EACC,SAAA;EACA,eAAA;EACA,SAAA;AA5BF;AA8BC;EACC,gBAAA;AA5BF;;AA+BA;EACC,iBAAA;AA5BD;;AA8BA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AA3BD;AA4BC;EACC,SAAA;AA1BF;;AA6BA;EACC,eAAA;EACA,mBAAA;AA1BD;;AA4BA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAzBD;;AA4BA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YA5Se;EA6Sf,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAzBD;;AA4BA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AAzBD;AA2BC;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAzBF;;AA6BA;EACC,oBAAA;AA1BD;;AA6BA;EACC,eAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AA1BD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n$padding-inline: 16px;\n$footer-height: 80px;\n\n.ion-padding {\n\tpadding: 12px;\n}\n\n.ion-margin {\n\tmargin: 12px;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: #fff;\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\n.image-wrapper {\n\twidth: 100%;\n\tposition: relative;\n\taspect-ratio: 512 / 316;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tion-img {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tborder-radius: 2px;\n\t\toverflow: hidden;\n\t\tobject-fit: contain;\n\n\t\t// &:not(.default-img) {\n\t\t// \tobject-fit: cover;\n\t\t// }\n\t}\n\n\t.default-img {\n\t\tbackground-color: #fff;\n\t\theight: 100%;\n\t\twidth: 78%;\n\t\t--logo-color: var(--ion-color-primary);\n\t}\n\n\t.info-product-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 6px;\n\t}\n\n\t.img-info {\n\t\tposition: absolute;\n\t\tbottom: -16px;\n\t\tright: 3%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tcolor: var(--ion-color-danger);\n\n\t\t@include mobile {\n\t\t\tfont-size: 9px;\n\t\t}\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: $footer-height;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\tpadding-bottom: 120px;\n\toverflow: auto;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.option-group-col {\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tmargin-top: 10px;\n\tpadding: 0 ($padding-inline - 5px);\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\tmargin: 0;\n\tfont-size: 40px;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 1;\n}\n\nion-toolbar {\n\t--ion-toolbar-color: white;\n\t--ion-toolbar-background: var(--ion-color-primary);\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tpadding: 8px;\n\t}\n}\n.menge {\n\tmargin-inline: $padding-inline;\n\tpadding: 16px 0 !important;\n\tborder-top: var(--outline-default);\n\tborder-bottom: var(--outline-default);\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.quantity {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 18px;\n\t\tline-height: 21.8px;\n\t\ttext-align: left;\n\t\tcolor: var(--color-black);\n\t}\n\n\tapp-quantity-selector {\n\t\t// --quantity-icon-background: var(--ion-color-secondary);\n\t\t// --quantity-icon-background-contrast: var(--ion-color-secondary-contrast);\n\t}\n}\n.select-size {\n\ttext-align: left;\n\tpadding: 10px 25px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tion-item {\n\t\tborder-radius: 5px;\n\t\tmargin-top: 10px;\n\t\tborder: 0.5px solid #e2dcd5;\n\t}\n}\n.info {\n\ttext-align: left;\n\tpadding: 24px $padding-inline !important;\n\n\t.title {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 24px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--color-black);\n\t\tmargin: 0px 0px 16px;\n\t\t// border-bottom: 1px solid var(--color-black);\n\n\t\twidth: 100%;\n\t\tpadding-bottom: 3px;\n\t}\n\n\t.desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 150%;\n\t\t// letter-spacing: 0.01em;\n\t\tvertical-align: middle;\n\t\tcolor: var(--color-grey);\n\t}\n\n\t.measurement {\n\t\tfont-size: 12px;\n\t\tline-height: 110%;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.title > span {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.info-icon {\n\tmargin-left: 5px;\n\tposition: relative;\n\tleft: unset;\n\tright: unset;\n\tbottom: unset;\n\ttop: unset;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n}\n\n.qty-row {\n\tmargin: 10px 0;\n\n\th2 {\n\t\tfont-size: 18px;\n\t}\n}\n\n.size-picker {\n\tmargin-top: 20px;\n\n\t.chip {\n\t\tbackground: #f5f5f5;\n\t\tcolor: #000;\n\n\t\t&.selected {\n\t\t\tbackground: #000;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n\n.step-counter {\n\tcolor: var(--ion-color-primary);\n}\n\n.first-toolbar {\n\tpadding: 12px;\n\tbackdrop-filter: blur(3px);\n\tcolor: black;\n}\n\n.option-group-description {\n\tmargin: 20px $padding-inline 0;\n\tcolor: var(--color-black);\n\tfont-family: AppFontMedium;\n\tfont-size: 20px;\n\tline-height: 24px;\n\tletter-spacing: -0.01em;\n\ttext-transform: uppercase;\n\ttext-align: left;\n}\n\n.first-page-header {\n\tbackground: red;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: white;\n\twidth: 100%;\n\tion-icon {\n\t\tzoom: 1.7;\n\t\tmargin: 0px 5px;\n\t\twidth: 8%;\n\t}\n\tion-title {\n\t\ttext-align: left;\n\t}\n}\n.button-price {\n\tmargin-left: 10px;\n}\n.header-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\tion-icon {\n\t\tzoom: 0.6;\n\t}\n}\napp-tag:has(ion-icon) {\n\tmargin-top: 7px;\n\tmargin-bottom: 16px;\n}\nion-item {\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.footer-container {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: $footer-height;\n\twidth: 100%;\n\tz-index: 999;\n\tbackground: white;\n\tpadding: 16px;\n}\n\n.footer-button {\n\twidth: 100%;\n\theight: 54px;\n\tmargin: 0;\n\n\tspan {\n\t\tfont-family: AppFontMedium;\n\t\tcolor: var(--color-white);\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\n\napp-universal-page-toolbar {\n\t--title-width: 192px;\n}\n\n.error-message {\n\tfont-size: 12px;\n\tmargin: 0;\n\tmargin-left: 16px;\n\tmargin-top: 6px;\n\ttext-align: start;\n\tcolor: var(--ion-color-danger);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
